(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-card-fallback/assets/javascripts/casino-card-fallback.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-card-fallback/assets/javascripts/casino-card-fallback.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const CasinoCardFallback = _ref => {
  let {
    title,
    subtitle = 'Otillgängligt spel',
    icon = 'eye-closed'
  } = _ref;
  return React.createElement("div", {
    className: "casino-card-fallback",
    "data-testid": "casino-card-fallback"
  }, React.createElement("div", {
    className: "casino-card-fallback__inner margin-bottom-1 margin-top-1"
  }, React.createElement(Icon, {
    className: "casino-card-fallback-icon",
    icon: icon,
    size: "600"
  }), React.createElement("p", {
    className: "f-500 margin-xs-top-1 f-uppercase f-bold"
  }, subtitle), React.createElement("h3", {
    className: "casino-game-promo-title margin-bottom-1 f-400"
  }, title)));
};
setGlobal('svs.components.casino_react.casinoCardFallback', CasinoCardFallback);

 })(window);